<header class="ff-header mb-4" id="frontfaceNavBar">
  <button class="skip-main position-absolute btn" (click)="skipToMain()">Skip to main content</button>
  <div class="container-fluid">
    <div class="row justify-content-between align-items-center">
      <div class="col-auto d-flex logo p-0">
        <img src="https://frostdesignsystem.learningmate.co/assets/images/logo/frost-align.svg" class="img-fluid" alt="Frost Align Logo">
      </div>

      <nav class="col navbar navbar-expand-lg">
        <ul class="navbar-nav mr-auto">
          <ng-container *ngFor="let item of navBarItems; let i = index">
            <li class="nav-item px-2" *ngIf="item.show">
              <button [attr.aria-label]="item.active? item.name + ' selected':null"
                [attr.aria-selected]="item.active?true:null" id="{{ item.name }}-button" type="button"
                (click)="navigate(item)" class="btn btn-clear btn-link position-relative text-uppercase font-bold px-0"
                [ngClass]="{'active':item.active}">{{item.name}}
              </button>
            </li>
          </ng-container>
        </ul>
      </nav>

      <div class="col-auto d-flex align-items-center justify-content-end">
        <div class="logo-client" *ngIf="logoPath?.length">
          <img [src]="logoPath" alt="" class="img-fluid" aria-hidden="true">
        </div>
        <div class="login-holder">
          <button type="button" class="btn btn-clear btn-link position-relative text-uppercase font-bold px-0" *ngIf="!hideLoginBtn"
            id="loginBtn" (click)="navigate({'path': 'login'})">Login
          </button>
        </div>
      </div>
    </div>
  </div>
</header>